import Vue from 'vue'
import { getMatchedComponentsInstances, promisify, globalHandleError } from './utils'
import NuxtLoading from './components/nuxt-loading.vue'

import _2d21a7c7 from '../layouts/base.vue'
import _6f6c098b from '../layouts/default.vue'
import _7d256e80 from '../layouts/locked.vue'
import _52cbc0eb from '../layouts/minimal.vue'

const layouts = { "_base": _2d21a7c7,"_default": _6f6c098b,"_locked": _7d256e80,"_minimal": _52cbc0eb }

export default {
  head: {"title":"Baianat","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"fbid","property":"fb:id","content":"1610780915683371"},{"hid":"description","name":"description","content":"Authentic solutions through digital innovation."},{"hid":"og:description","name":"og:description","property":"og:description","content":"Authentic solutions through digital innovation."},{"hid":"og:title","name":"og:title","property":"og:title","content":"Baianat"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:image","name":"og:image","property":"og:image","content":"https:\u002F\u002Fcdn.baianat.com\u002Fstatic\u002Fshare.png"},{"hid":"twitter:image","name":"twitter:image","property":"twitter:image","content":"https:\u002F\u002Fcdn.baianat.com\u002Fstatic\u002Fshare.png"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"theme-color","content":"#1a3aff"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Baianat"},{"hid":"author","name":"author","content":"support@baianat.com"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"Baianat"}],"noscript":[{"innerHTML":"This website requires JavaScript to deliver the best possible experience."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fiphone5_splash.png","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2)"},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fiphone6_splash.png","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2)"},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fiphoneplus_splash.png","media":"(device-width: 621px) and (device-height: 1104px) and (-webkit-device-pixel-ratio: 3)"},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fiphonex_splash.png","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3)"},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fiphonexr_splash.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2)"},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fiphonexsmax_splash.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3)"},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fipad_splash.png","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2)"},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fipadpro1_splash.png","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2)"},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fipadpro3_splash.png","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2)"},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fipadpro2_splash.png","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2)"},{"rel":"preconnect","href":"https:\u002F\u002Fscript.hotjar.com"},{"rel":"preconnect","href":"https:\u002F\u002Fstatic.hotjar.com"},{"rel":"preconnect","href":"https:\u002F\u002Fin.hotjar.com"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.8102d50e.json"},{"rel":"shortcut icon","href":"\u002Ffavicons\u002Fandroid-icon-36x36.png"},{"rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512.0aaa33.png","sizes":"512x512"}],"style":[],"script":[]},

  render(h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [ templateEl ])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl])
  },
  data: () => ({
    isOnline: true,
    layout: null,
    layoutName: ''
  }),
  beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this
      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  mounted() {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline() {
      return !this.isOnline
    }
  },
  methods: {
    refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },
    async refresh() {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()
      const promises = pages.map(async (page) => {
        const p = []

        if (page.$options.fetch) {
          p.push(promisify(page.$options.fetch, this.context))
        }
        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }
        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail()
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },

    errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },

    setLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
  },
  components: {
    NuxtLoading
  }
}
